import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { KioskService } from '../kiosk.service';
import { BehaviorSubject, Observable, forkJoin} from 'rxjs';
import { map, toArray} from 'rxjs/operators';
import { Kiosk } from '../models/kiosk';
import { finalize } from 'rxjs/operators';
import { LicenseService } from '../license.service';
import { License } from '../models/license';
import { LicenseTypes } from '../models/license';
import { AccountService } from '../account.service';
import { MatDialog } from '@angular/material';
import { KioskEditComponent } from '../kiosk-edit/kiosk-edit.component';
import { KioskEditDialogComponent } from '../kiosk-edit-dialog/kiosk-edit-dialog.component';
import { KioskEditTenantDialogComponent } from '../kiosk-edit-tenant-dialog/kiosk-edit-tenant-dialog.component';
import { KioskDiagnosticsDialogComponent } from '../kiosk-diagnostics-dialog/kiosk-diagnostics-dialog.component';
import { KioskDecommissionDialogComponent } from '../kiosk-decommission-dialog/kiosk-decommission-dialog.component';

@Component({
  selector: 'app-kiosk-list',
  templateUrl: './kiosk-list.component.html',
  styleUrls: ['./kiosk-list.component.css']
})
export class KioskListComponent implements OnInit {
  search = '';
  displayedColumns: string[] = [
    // 'id',
    'nickname',
    'account',
    // 'company',
    // 'timezone',
    // 'locked',
    'tenants',
    'last_ping',
    'licenses',
    'device',
    // 'model',
    'actions'
  ];
  
  allColumns: string[] = [
    'id',
    'nickname',
    'account',
    'company',
    'timezone',
    'locked',
    'multi_tenant',
    'tenants',
    'last_ping',
    'licenses',
    'model',
    'device',
    'actions'
  ];

  kiosks$ = new BehaviorSubject<Kiosk[]>([]);
  isLoading$ = new BehaviorSubject<boolean>(false);
  loading = false;
  dataSource: MatTableDataSource<Kiosk>;
  selKiosk;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private _kioskService: KioskService, private _licenseService: LicenseService,
     private _accountService: AccountService, public dialog: MatDialog) {}

  ngOnInit() {
    this.getKiosks();
  }

  getKiosks() {
    this.isLoading$.next(true);

    forkJoin(this._kioskService.getKiosks(), this._licenseService.getLicenses())
      .pipe(
        finalize(() => this.isLoading$.next(false)),
    ).subscribe(res => {

      res[0].kiosks.forEach((el: any) => {
        el.licenses = res[1].filter((d) => Number(d.device_id) === el.device_id);
        this._accountService.byId(el.account_id).subscribe((acc) => {
          if (acc) {
            el.account = acc;
            el.account_email = acc.email;
          }
        });
        this._accountService.deviceById(el.device_id).subscribe((d) => {
          if (d) {
            el.device = d;
            el.device_imei = d.imei;
            el.device_model = d.model;
          }

        });
        el.tenants = res[0].kiosk_tenants.filter((kt) => Number(kt.kiosk_id) === el.id);
      });

      this.kiosks$.next(res[0].kiosks.sort((a, b) => b.id - a.id));
      this.dataSource = new MatTableDataSource<Kiosk>(this.kiosks$.getValue());
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.applyFilter(this.search); // hacky and not good

    });
  }
  isSetup(k: any) {
    const kioskHasLicense = k.licenses && k.licenses.length !== 0;
    const kioskHasAccount = k.account_id && k.account_id !== 0;

    return kioskHasLicense && kioskHasAccount && k.device_id;
  }
  openDialog(row: any) {
    const dialogRef = this.dialog.open(KioskEditDialogComponent, {
      width: '400px',
      data: { kiosk: row }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result === 'refresh') {
        this.getKiosks();
      }
    });
  }

  openEditTenantDialog(row: any) {
    const dialogRef = this.dialog.open(KioskEditTenantDialogComponent, {
      width: '800px',
      data: { kiosk: row }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if ( result === 'refresh') {
        this.getKiosks();
      }
    });
  }
  
  openKioskDiagnostics(row: any) {
    const dialogRef = this.dialog.open(KioskDiagnosticsDialogComponent, {
      width: '800px',
      data: { kiosk: row }
    });
  }
  
  openKioskDecommission(row: any) {
    const dialogRef = this.dialog.open(KioskDecommissionDialogComponent, {
      width: '800px',
      data: { kiosk: row }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if (result === 'refresh') {
        this.getKiosks();
      }
    });
  }
  
  openEditMember(row: any) {
    const dialogRef = this.dialog.open(KioskEditTenantDialogComponent, {
      width: '800px',
      data: { kiosk: row }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      if ( result === 'refresh') {
        this.getKiosks();
      }
    });
  }

  getLicenses(el: any[]) {
    return el.map((d) => d.type).join(',');
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  migrateKiosk(id: number) {
    this.loading = true;
    this._kioskService.migrateKiosk(id).pipe(
      finalize(() => this.loading = false)
    ).subscribe(res => {
      console.log(res);
      this.getKiosks();
    });
  }

  selectKiosk(row: any) {
    this.selKiosk = Object.assign({}, row);
  }

  // garbage code
  convertOldLicense(id: number, device_id: number) {
    this.loading = true;
    this._kioskService.getOldLicenses(id).pipe(
      map((d: any) => {
        return d.map((a) => ({account_id: a.account_id, app: a.app}));
        }
      ),
    ).subscribe(res => {

      if (res.length === 0) {
        this.loading = false;
      }

      res.forEach(el => {
        console.log('creating', el);
        const l = new License();

        l.account_id = el.account_id;
        l.active = true;
        l.credits = 0;
        l.track_credits = false;

        if (Number(el.app) === 1) {
          l.type = LicenseTypes.HEARKIOSKDIN;
        } else {
          l.type = LicenseTypes.HEARKIOSKPTA;
        }

        this._licenseService.saveLicense(l).subscribe((a) => {
          this._licenseService.LinkLicenseToDevice(a.id, device_id).subscribe((b) => {
            this.loading = false;
            this.getKiosks();
          });
        });
      });
    });
  }

}





// WEBPACK FOOTER //
// ./src/app/kiosk-list/kiosk-list.component.ts